import React, { useEffect, useState } from "react";
import { marked } from "marked";

type MarkdownMarkedProps = {
    content: string;
};

const MarkdownMarked: React.FC<MarkdownMarkedProps> = ({ content }) => {
    const [html, setHtml] = useState<string>("");

    useEffect(() => {
        let cancelled = false;
        // Convert richtext
        const convertMarkdown = async () => {
            const result = await marked.parse(content); // string | Promise<string> handled
            if (!cancelled) {
                setHtml(result as string);
            }
        };
        convertMarkdown();

        return () => {
            cancelled = true;
        };
  }, [content]);

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default MarkdownMarked;
